var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 90,
    viewBox: "0 0 57 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3527 1H22.1782L22.44 2.6L17.6691 7.57454L17.6109 12.3455L12.1127 16.4764L11.9091 19.6473L9.93092 21.4509L8.0691 26.7455L9.0291 32.7673L10.1055 35.7345L8.50546 37.9164L9.9891 39.2255L8.91274 41.1745L10.0182 43.7927L10.0764 46.9636L12.9273 50.3382L8.97092 52.3455L10.0182 56.04L5.04365 61.3345L4.11274 67.0655L1 69.0436L2.16362 74.2509L30.8182 74.28L28.7818 80.1564L32.3018 86.7891L32.68 88.1273L35.1527 89L36.84 85.5382L38.0036 86.6145L43.4727 85.2182L45.8 85.8873L47.3418 85.3927L49.7563 86.3527L51.0363 85.3636L50.2218 56.4182L55.8073 3.56L54.3527 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/MS.0420a80bcf6ad8f15ca1ab66eacf77b0.svg";
export { ForwardRef as ReactComponent };